export const transition = { 
    duration: .25, 
    ease: [.56, .03, .12, 1.04]
};

export const variants = { 
    initial: { 
        opacity: 0,
    }, 
    animate: { 
        opacity: 1,
    }
};

export const collapseVariants = {
    open: {
        height: 'auto',
        opacity: 1,
        transition: { duration: 0.2, ease: 'easeOut' },
    },
    collapsed: {
        height: 0,
        opacity: 0,
        transition: { duration: 0.15, ease: 'easeIn' },
    },
};
